import { SettingsSchemaGeneralAxeCoreVersionValueEnum as AxeCoreVersion } from '@deque/orgwide-settings-client';

export const axeCoreVersions: AxeCoreVersion[] = Object.values(AxeCoreVersion);
